<div class="mx-5 my-3">
  <div *ngIf="showErrorMsg" class="alert alert-danger" role="alert">
    Votre identification n'a pas pu être validée. Merci de vérifier l'exactitude
    de votre saisie ainsi que le respect des majuscules et minuscules.<br />
    Si le problème persiste, contactez le service client au
    0&nbsp;800&nbsp;710&nbsp;620.
  </div>
  <div
    *ngIf="showResetPasswordSuccessMsg"
    class="alert alert-success"
    role="alert"
  >
    Votre mot de passe a bien été réinitialisé.
  </div>
  <div *ngIf="showValidateSuccessMsg" class="alert alert-success" role="alert">
    L'opération a été réalisée avec succès.
  </div>
  <div *ngIf="showSessionExpiredMsg" class="alert alert-danger" role="alert">
    <strong>Erreur ! </strong>
    <span>Votre session a expiré.</span>
  </div>
  <div *ngIf="showUseIdnotErrorMsg" class="alert alert-danger" role="alert">
    Pour les utilisateurs notaires, merci d'utiliser la mire de connexion ID.NOT ci-dessus.
  </div>
  <div *ngIf="showOrganismExistErrorMsg" class="alert alert-danger" role="alert">
    Un organisme avec ces informations existe déjà, merci de vous connecter ou de contacter le support.
  </div>
  <div *ngIf="showDefaultErrorMsg" class="alert alert-danger" role="alert">
    <span>{{ defaultErrorMsg }}</span>
  </div>
</div>
